export const MAX_NEWS_DESCRIPTION_LENGTH = 600;

export const MIN_IMG_FILE_SIZE = 5 * 1024 * 1024;
